export const tr = {
  // Navigation
  nav: {
    home: 'Ana Sayfa',
    services: 'Servislerimiz',
    about: 'Hakkımızda',
    contact: 'İletişim',
  },

  // Header
  header: {
    quote: 'Teklif Alın',
    quickQuote: 'Hızlı & Kolay Teklif',
    openMenu: 'Menüyü aç',
    closeMenu: 'Menüyü kapat',
  },

  // Hero Carousel
  hero: {
    featured: 'Öne çıkan görseller',
    loading: 'Yükleniyor',
    noImages: 'Görsel bulunamadı. /public/img/carousel/ klasörüne carousel_0.png, carousel_1.png, ... şeklinde görseller ekleyin.',
    prev: 'Önceki slayt',
    next: 'Sonraki slayt',
    selector: 'Slayt seçici',
    goTo: 'Slayt {0}\'e git',
    slide: 'Slayt {0} / {1}',
    carouselImage: 'Carousel görseli {0}',
  },

  // About Section
  // About Section
  about: {
    companyLabel: 'TMR GLOBAL DIŞ TİCARET VE LİMİTED ŞİRKETİ',
    title: 'HAKKIMIZDA',
    missionTitle: 'Hedefimiz',
    description: "Şirket, 2022 yılında iş makinesi parçaları ve elektronik aksam ihracatıyla faaliyetlerine başlamıştır. Daha sonra ABD ve Avrupa'da akredite olduğu uçak firmalarından çeşitli uçak sarf malzemeleri tedarik ederek Ortadoğu ülkelerine (Umman, Dubai, Mısır vb.) düzenli parça tedariği gerçekleştiren bir yapıya dönüşmüştür. 2025 Mayıs itibarıyla Uluslararası Hava Taşımacılığı Birliği (IATA) üyesi olarak, tüm uluslararası alış-satış operasyonlarının hava kargo taşımacılığını kendi bünyesinde yürüten, global uçak kargo lojistiği sağlayıcısı konumuna gelmiştir.",
    buttonText: 'DAHA FAZLA BİLGİ',
    inventoryLabel: 'HİZMETLERİMİZ',
    inventoryTitle: 'ÇÖZÜMLER',
    stats: {
      experience: { value: '3+', label: 'Yıllık Deneyim' },
      global: { value: '10+', label: 'Ülkeye İhracat' },
      clients: { value: '50+', label: 'Mutlu Müşteri' },
    },
  },

  // Tracking Section
  tracking: {
    title: 'Kargonuzu Takip Edin',
    description: 'Kargonuzun nerede olduğunu öğrenmek için takip numaranızı girin',
    placeholder: 'Takip numaranızı girin (Örn: DEMO)',
    track: 'Takip Et',
    searching: 'Aranıyor...',
    error: 'Lütfen takip numarası giriniz',
    notFound: 'Kargo bulunamadı. Lütfen DEMO yazarak demo verilerini görün.',
    hint: '💡 Demo için <strong>DEMO</strong> yazın',
    helpText: 'Yardıma mı ihtiyacınız var?',
    trackingLabel: 'Takip numarası',
    demoSteps: {
      step1: {
        title: 'Kargo Alındı',
        location: 'Ankara Depo',
      },
      step2: {
        title: 'Havaalanında',
        location: 'Esenboğa Havalimanı',
      },
      step3: {
        title: 'Uçuşta',
        location: "İstanbul'a Doğru",
      },
      step4: {
        title: 'Dağıtım Merkezinde',
        location: 'İstanbul Depo',
      },
      step5: {
        title: 'Teslimat',
        location: 'Adresinizde',
      },
    },
    estimatedDelivery: '25 Kasım 2025',
  },

  // Contact page & form
  contact: {
    formTitle: 'Bize Mesaj Gönderin',
    nameLabel: 'Adınız Soyadınız',
    namePlaceholder: 'Adınız Soyadınız',
    emailLabel: 'E-posta Adresiniz',
    emailPlaceholder: 'ornek@email.com',
    phoneLabel: 'Telefon',
    phonePlaceholder: '+90 5XX XXX XX XX',
    subjectLabel: 'Konu',
    subjectPlaceholder: 'Mesajınızın konusu',
    messageLabel: 'Mesajınız',
    messagePlaceholder: 'Mesajınızı buraya yazın...',
    sendButton: 'Mesaj Gönder',
    sending: 'Gönderiliyor...',
    success: 'Mesajınız başarıyla gönderildi.',
    error: 'Bir hata oluştu.',
  },

  // Quote Form older keys (kept for backward compatibility if needed)
  quote: {
    cargoInfo: 'Kargo Bilgileri',
    contactInfo: 'İletişim Bilgileriniz',
    cargoType: 'Seçiniz',
    cargoTypeLabel: 'Kargo Tipi',
    shipmentTypeLabel: 'Gönderi Türü',
    fromLabel: 'Nereden',
    toLabel: 'Nereye',
    weightLabel: 'Ağırlık (KG)',
    volumeLabel: 'Hacim (M³)',
    companyLabel: 'Firma Adı / Ünvanı',
    firstNameLabel: 'Adınız',
    lastNameLabel: 'Soyadınız',
    emailLabel: 'E-posta Adresiniz',
    phoneLabel: 'Telefon',
    messageLabel: 'Mesajınız',
    fromPlaceholder: 'Çıkış noktası',
    toPlaceholder: 'Varış noktası',
    weightPlaceholder: '0',
    volumePlaceholder: '0',
    companyPlaceholder: 'Şirket adı',
    firstNamePlaceholder: 'Adınız',
    lastNamePlaceholder: 'Soyadınız',
    emailPlaceholder: 'ornek@email.com',
    phonePlaceholder: '+90 5XX XXX XX XX',
    messagePlaceholder: 'Ek bilgi veya özel istekleriniz...',
    cancel: 'Vazgeç',
    submit: 'Formu Gönder',
    submitting: 'Gönderiliyor...',
    cargoTypes: {
      air: 'Hava Kargo',
      road: 'Kara Yolu',
      sea: 'Deniz Yolu',
      express: 'Express',
    },
    shipmentTypes: {
      import: 'İthalat',
      export: 'İhracat',
      domestic: 'Yurtiçi',
    },
  },

  // Footer
  footer: {
    company: 'Şirket',
    companyName: 'TMR GLOBAL',
    companySubtitle: 'Dış Ticaret ve Limited Şirketi',
    companyDescription: 'Şirket, 2022 yılında iş makinesi parçaları ve elektronik aksam ihracatıyla faaliyetlerine başlamıştır. 2025 Mayıs itibarıyla Uluslararası Hava Taşımacılığı Birliği (IATA) üyesi olarak, global uçak kargo lojistiği sağlayıcısı konumuna gelmiştir.',
    socialLinks: 'Sosyal medya bağlantıları',
    visitSocial: '{0} sayfamızı ziyaret edin',
    contactTitle: 'İLETİŞİM',
    companyInfoTitle: 'ŞİRKET BİLGİLERİ',
    footerNav: 'Footer navigasyonu',
    legalLinks: 'Yasal bağlantılar',
    copyright: '© {0} TMR Global Dış Ticaret ve Limited Şirketi. Tüm Hakları Saklıdır.',
    privacy: 'Gizlilik Politikası',
    terms: 'Kullanım Koşulları',
    viewCertificate: 'IATA Sertifikasını Görüntüle',
    certificateTitle: 'IATA Sertifikası',
    close: 'Kapat',
    services: 'Hizmetler',
    getQuote: 'Teklif Al',
  },

  // Pages
  pages: {
    services: {
      title: 'Servislerimiz',
      subtitle: 'Uluslararası lojistik ve taşımacılıkta kapsamlı çözümler',
    },
    contact: {
      title: 'İletişim',
      subtitle: 'Lojistik uzmanlarımızla iletişime geçin',
      sectionAria: 'İletişim bilgileri ve form',
    },
  },

  // About page structured data
  aboutPage: {
    hero: {
      title: 'Hakkımızda',
      subtitle: 'Global uçak kargo lojistiği ve parça tedarikinde uçtan uca çözüm',
    },
    story: {
      title: 'Hikayemiz',
      content: "Şirket, 2022 yılında iş makinesi parçaları ve elektronik aksam ihracatıyla faaliyetlerine başlamıştır. Daha sonra ABD ve Avrupa’dan akredite olduğu uçak firmalarından çeşitli uçak sarf malzemeleri tedarik ederek Ortadoğu ülkelerine (Umman, Dubai, Mısır vb.) düzenli parça tedariği gerçekleştiren bir yapıya dönüşmüştür. 2025 Mayıs itibarıyla Uluslararası Hava Taşımacılığı Birliği (IATA) üyesi olarak, tüm uluslararası alış-satış operasyonlarının hava kargo taşımacılığını kendi bünyesinde yürüten, global uçak kargo lojistiği sağlayıcısı konumuna gelmiştir.",
      highlights: [
        '2022: İş makinesi parçaları ve elektronik aksam ihracatıyla başlangıç',
        'ABD ve Avrupa’daki akredite uçak firmalarından sarf malzeme tedariki',
        'Ortadoğu ülkelerine (Umman, Dubai, Mısır vb.) düzenli parça tedariği',
        'Mayıs 2025: IATA üyeliği ve hava kargo operasyonlarını kendi bünyesinde yürütme',
      ],
    },
    vision: {
      title: 'Vizyonumuz',
      content: 'Uluslararası tedarik ve hava kargo lojistiğinde güvenilir, sürdürülebilir ve tercih edilen bir çözüm ortağı olmak; müşterilerimize uçtan uca planlanan, şeffaf ve zamanında operasyonlarla değer katmak.',
      goals: [
        'Sürdürülebilir lojistik uygulamaları',
        'Dijital dönüşüm lideri',
        'Global ağ genişlemesi',
        'Müşteri memnuniyetinde mükemmellik',
      ],
    },
    mission: {
      title: 'Misyonumuz',
      content: 'ABD ve Avrupa’daki akredite tedarik ağımızdan temin edilen uçak sarf malzemelerini; Ortadoğu başta olmak üzere hedef pazarlara düzenli, güvenli ve planlı şekilde ulaştırmak. IATA üyeliğimiz doğrultusunda uluslararası alış-satış süreçlerinin hava kargo taşımacılığını kendi bünyemizde yürüterek uçak kargo lojistiğinde bütünleşik hizmet sunmak.',
      values: [
        'Güvenilirlik ve şeffaflık',
        'Müşteri odaklı hizmet',
        'Kalite ve mükemmellik',
        'Sürekli gelişim ve yenilik',
      ],
    },
    stats: [
      { number: '2022', label: 'Faaliyet Başlangıcı' },
      { number: '2025', label: 'IATA Üyeliği (Mayıs)' },
      { number: 'ABD & Avrupa', label: 'Akredite Tedarik Ağı' },
      { number: 'Ortadoğu', label: 'Düzenli Parça Tedariği' },
    ],
  },

  // Components
  serviceCard: {
    details: 'Detaylı Bilgi',
    detailsAria: '{0} hakkında detaylı bilgi',
  },

  // Tracking Help
  trackingHelp: {
    or: 'veya',
  },

  // Contact page & form
  contactForm: {
    title: 'Bize Mesaj Gönderin',
    success: 'Mesajınız başarıyla gönderildi. En kısa sürede size dönüş yapacağız.',
    error: 'Bir hata oluştu. Lütfen tekrar deneyin.',
    nameLabel: 'Adınız Soyadınız',
    emailLabel: 'E-posta Adresiniz',
    messageLabel: 'Mesajınız',
    namePlaceholder: 'Adınız Soyadınız',
    emailPlaceholder: 'ornek@email.com',
    messagePlaceholder: 'Mesajınızı buraya yazın...',
    submit: 'Mesaj Gönder',
    submitting: 'Gönderiliyor...',
  },

  // Contact info card
  contactInfo: {
    title: 'İletişim Bilgileri',
    phoneLabel: 'Telefon',
    emailLabel: 'E-posta',
    addressLabel: 'Adres',
    mapPlaceholder: 'Harita yakında eklenecek',
  },

  // Services data (from servicesData.json)
  servicesData: {
    services: [
      {
        id: 1,
        title: 'Uçak Parçaları ve Sarf Malzemeleri Tedariği',
        icon: 'FiSettings',
        description: "ABD ve Avrupa'daki akredite üreticilerden temin edilen uçak yedek parçaları ve sarf malzemelerini, Ortadoğu başta olmak üzere global havacılık sektörüne güvenle ulaştırıyoruz.",
        features: ['Onaylı Tedarik Ağı', 'Hızlı Parça Temini', 'AOG (Acil) Hizmetler']
      },
      {
        id: 2,
        title: 'IATA Onaylı Hava Kargo Lojistiği',
        icon: 'FiSend',
        description: 'Uluslararası Hava Taşımacılığı Birliği (IATA) üyesi olarak, tüm hava kargo operasyonlarınızı kendi bünyemizdeki yetkinliklerle, hızlı ve standartlara uygun şekilde yönetiyoruz.',
        features: ['Global IATA Ağı', 'Öncelikli Kargo', 'Charter Çözümleri']
      },
      {
        id: 3,
        title: 'İş Makinesi ve Elektronik Aksam İhracatı',
        icon: 'FiCpu',
        description: '2022 yılından bu yana süregelen tecrübemizle, iş makineleri parçaları ve hassas elektronik aksamların ihracatını, uzman kadromuzla sorunsuz bir şekilde gerçekleştiriyoruz.',
        features: ['Hassas Taşıma', 'Teknik Uzmanlık', 'Gümrükleme Desteği']
      },
      {
        id: 4,
        title: 'Transit Ticaret ve Cross-Trade',
        icon: 'FiGlobe',
        description: 'Türkiye üzerinden veya direkt olarak üçüncü ülkeler arasındaki ticaretinizi yönetiyor; ABD, Avrupa ve Ortadoğu arasındaki tedarik zincirini optimize ediyoruz.',
        features: ['Üçüncü Ülke Taşımaları', 'Belge Yönetimi', 'Maliyet Optimizasyonu']
      }
    ]
  },


};
